export default __webpack_public_path__ + "static/media/loading.b5cab425.gif";